export enum MigrationStatus {
  initialize = "initializing migration",
  reject = "rejecting migration",
  metadata = "metadata",
  fixed = "fixed",
  migrating = "migration in progress",
  staged = "staged",
  migrated = "migration complete",
  exception = "exception",
  fk_exception = "missing related entity",
  double_migrated = "already migrated",
  in_progress = "in_progress",
  //----- this is a status for empty value received
  unknown = "unknown",
}

export enum MigrationDbTables {
  STUDY = "study",
  USER = "user",
  ORGANIZATION = "organization",
  ORGANIZATION_STUDY = "organization_study",
  CONTACT = "contact",
  PRINCIPAL_INVESTIGATOR = "principal_investigator",
  SITE = "site",
  STUDY_CONTACT = "study_contact",
  ADDRESS = "address",
  ADDRESS_ENTITY = "address_entity",
  WORKSPACE = "workspace",
  FACILITY = "facility",
  FACILITY_LOCATION_SUBMISSION = "facility_location_submission",
  SITE_FACILITY = "site_facility",
  DOCUMENT_TYPE = "document_type",
  ORGANIZATION_TYPE = "organization_type",
  DOCUMENT = "document",
  WORKSPACE_REVIEW = "workspace_review",
  REVIEW_ENTITY = "review_entity",
  REVIEW_HOLD = "review_hold",
}

export enum ServerErrorCodes {
  accessDeny = 403,
  notFound = 404,
  unauthorized = 401,
  goneClient = 410,
  internalServer = 500,
  businessLayerError = 400,
}

export const UiEvents = [
  "mousemove",
  "mousedown",
  "mouseup",
  "click",
  "dblclick",
  "wheel",
  "scroll",
  "keydown",
  "keyup",
  "touchstart",
  "touchmove",
  "touchend",
  "input",
  "focus",
];
